import { render } from "./top.vue?vue&type=template&id=72a70982&scoped=true"
const script = {}

import "./top.vue?vue&type=style&index=0&id=72a70982&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a70982"]])

export default __exports__